export const NON_MARKETABLE = 'NonMarketable';
export const SINGLE_OPT_IN = 'SingleOptIn';
export const CONFIRMED = 'Confirmed';
export const UNSUBSCRIBED = 'Unsubscribed';
export const UNENGAGED_NON_MARKETABLE = 'UnengagedNonMarketable';
export const UNENGAGED_MARKETABLE = 'UnengagedMarketable';
